import React from "react";

import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";

import styles from "./styles";
const useStyles = makeStyles(styles);

function LetterItem({ letter, active, onSelect, disable }) {
  const classes = useStyles();
  const handleSelect = () => onSelect(letter);
  const aditionalClass = disable ? "disable" : active ? "active" : "";

  return (
    <ListItem
      button
      disableGutters
      className={[classes.container, classes[aditionalClass]].join(" ")}
      onClick={handleSelect}
    >
      <ListItemText
        disableTypography
        primary={letter}
        className={classes.text}
      />
    </ListItem>
  );
}

export default LetterItem;
